import {postToHub} from "./networkActions";
import {updateCart} from "./cartActions";


export async function removeTacEntryFromCart(cartEntryId) {
    const payload = [{
        type: "Tac",
        id:cartEntryId,
        action: "remove",
    }];

    await postToHub('prebooking/cart', payload);
    await updateCart();
}

